export const ageRangeList = [
  { value: "GE", label: "Gestante" },
  { value: "RN", label: "Recém-nascido" },
  { value: "1", label: "1 mês" },
  { value: "2", label: "2 meses" },
  { value: "3", label: "3 meses" },
  { value: "4", label: "4 meses" },
  { value: "5", label: "5 meses" },
  { value: "6", label: "6 meses" },
  { value: "7", label: "7 meses" },
  { value: "8", label: "8 meses" },
  { value: "9", label: "9 meses" },
  { value: "10", label: "10 meses" },
  { value: "11", label: "11 meses" },
  { value: "12", label: "12 meses" },
  { value: "13", label: "13 a 18 meses" },
  { value: "19", label: "19 a 24 meses" },
  { value: "25", label: "25 a 36 meses" },
];